import React from 'react';
import { AboutSection } from './components/AboutSection';
import { BonusesSection } from './components/BonusesSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { HeroSection } from './components/HeroSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { KitContentsSection } from './components/KitContentsSection';
import { PainPointsSection } from './components/PainPointsSection';
import { PricingSection } from './components/PricingSection';
import { StatsBar } from './components/StatsBar';
import { TestimonialsSection } from './components/TestimonialsSection';
import { TransformationSection } from './components/TransformationSection';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-text selection:bg-brand-green/20" data-id="element-0" data-mp="23w4fq47h1a2f">
      <main data-id="element-1" data-mp="3ikqz80j1f669">
        <HeroSection data-id="element-2" data-mp="3ij64oawq3n8e" />
        <StatsBar data-id="element-3" data-mp="3ijpcuzwkmx98" />
        <TransformationSection data-id="element-4" data-mp="3ii4qvyobommz" />
        <PainPointsSection data-id="element-5" data-mp="3mkrd9k285fcs" />
        <KitContentsSection data-id="element-6" data-mp="3mjzsz5e2v41t" />
        <InstantAccessSection data-id="element-7" data-mp="3mj6ipufwtwex" />
        <BonusesSection data-id="element-8" data-mp="3rbrayrj641gc" />
        <PricingSection data-id="element-9" data-mp="3rdkhm6ts6loc" />
        <GuaranteeSection data-id="element-10" data-mp="3rd189ei755lx" />
        <TestimonialsSection data-id="element-11" data-mp="5yhgo69t1c8" />
        <AboutSection data-id="element-12" data-mp="682rygdekbl" />
        <FAQSection data-id="element-13" data-mp="5ggje8nxyxz" />
        <FinalCTASection data-id="element-14" data-mp="82j0zgp5o9c" />
      </main>
      <Footer data-id="element-15" data-mp="2zlld2w2kqak3" />
    </div>;
}